module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVR4nGNggII7d+78Z0AGIAEYRhFAZ2OqxGYmAMotKuXGxB/mAAAAAElFTkSuQmCC"